import React from 'react'
import {Doughnut} from 'react-chartjs-2'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  ChartOptions,
  Plugin,
} from 'chart.js'

ChartJS.register(ArcElement, Tooltip)

const centerTextPlugin: Plugin<'doughnut'> = {
  id: 'centerText',
  beforeDraw: chart => {
    const {width, height, ctx} = chart
    if (!ctx) return

    ctx.save()

    const dataset = chart.data.datasets[0].data
    const percentage = dataset[0]

    ctx.font = 'bold 22px Public Sans'
    ctx.fillStyle = '#393939'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText(`${percentage}%`, width / 2, height / 2 - 10)

    if (percentage <= 60) {
      ctx.font = 'bold 16px Public Sans'
      ctx.fillStyle = '#393939'
      ctx.fillText('Low', width / 2, height / 2 + 15)
    }

    ctx.restore()
  },
}

type Props = {
  examResultsTotals?: {
    reported: number
    notReported: number
    total: number
  }
}

const ExamChart = ({examResultsTotals}: Props) => {
  const reportedPercentage = Math.round(
    examResultsTotals
      ? (examResultsTotals.reported / examResultsTotals.total) * 100
      : 0,
  )
  const notReportedPercentage = Math.round(
    examResultsTotals
      ? (examResultsTotals.notReported / examResultsTotals.total) * 100
      : 0,
  )

  const data = {
    labels: ['Exam Results Reported', 'Exam Results Not Reported'],
    datasets: [
      {
        data: [
          isNaN(reportedPercentage) ? 0 : reportedPercentage,
          isNaN(reportedPercentage) ? 100 : notReportedPercentage,
        ],
        backgroundColor: ['#1377D4', '#E7F1FA'],
        hoverBackgroundColor: ['#1377D4', '#E7F1FA'],
        borderWidth: 0,
      },
    ],
  }

  const options: ChartOptions<'doughnut'> = {
    cutout: '60%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        position: 'nearest',
        callbacks: {
          label: tooltipItem => {
            const value = tooltipItem.raw as number
            return `${tooltipItem.label}: ${value}%`
          },
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  }

  return <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
}

export default ExamChart
